import { computed, unref } from 'vue'
import store from '@/store/index'

/**
 * Whether the current user may see salary data, matching the backend's
 * canViewOrEditSalary: admin of the main board, or payRate view/edit in their
 * access scopes. Scenario-level admin does not count; sharing a scenario grants
 * it, while the backend still strips compensation from those users.
 * @param {import('vue').MaybeRef<string>} mainBoardId
 * @returns {import('vue').ComputedRef<boolean>}
 */
export default function useCanViewSalary(mainBoardId) {
  return computed(
    () =>
      store.getters.isAdmin(unref(mainBoardId)) ||
      !!store.getters['accessScopes/fieldPermissions']?.scopedPermissions?.payRate
  )
}
